import { render, staticRenderFns } from "./SkeletonRawMaterialComponent.vue?vue&type=template&id=d68638ea&scoped=true&"
import script from "./SkeletonRawMaterialComponent.vue?vue&type=script&lang=js&"
export * from "./SkeletonRawMaterialComponent.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonRawMaterialComponent.vue?vue&type=style&index=0&id=d68638ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d68638ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
